"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
class ReduxMemoryCache {
}
ReduxMemoryCache.Store = redux_1.createStore((state = {}, action) => {
    switch (action.type) {
        case "insert":
            return Object.assign({}, state, { [action.data.objectUuid]: action.data });
        case "delete":
            const _a = action.data.objectUuid, _ = state[_a], newState = __rest(state, [typeof _a === "symbol" ? _a : _a + ""]);
            return newState;
        default:
            return state;
    }
});
exports.default = ReduxMemoryCache;
//# sourceMappingURL=ReduxMemoryCache.js.map